import { Chip } from '@mui/material';
import { styled } from '@mui/material/styles';
import SvgIconStyle from '../../components/SvgIconStyle';

// ------------------------------------------------------------

export default function JobPostStatusChip({ status }) {
  if (['complete', 'stop', 'waiting-no-hurry'].includes(status)) {
    return (
      <Chip
        size="small"
        icon={<SvgIconStyle src={"/icons/icon-equal-mono.svg"} sx={{ color: "text.secondary", ml: 0.5, width: 20, height: 20, transform: "rotate(90deg)" }} />}
        label="매칭 종료"
        sx={{ fontSize: "12px", fontWeight: "bold", color: "text.disabled", "& .MuiChip-label" : { pl: 0 } }}
      />
    )
  } else if(['review-requested', 'write-requested'].includes(status)) {
    return (
      <Chip
        size="small"
        icon={<SvgIconStyle src={"/icons/icon-check-circle-mono.svg"} sx={{ color: "text.secondary", ml: 1, width: 14, height: 14 }} />}
        label="검토 중"
        sx={{ fontSize: "12px", fontWeight: "bold", "& .MuiChip-label" : { pl: 0.5 } }}
      />
    )
  } else if (['position-set', 'method-direct', 'method-paste', 'external-link-set', 'write-position', 'detail-position-set', 'context-set', 'monthly-budget-set', 'task-set'].includes(status)) {
    return (
      <Chip
        size="small"
        icon={<SvgIconStyle src={"/icons/icon-pencil-mono.svg"} sx={{ color: "text.secondary", ml: 1, width: 16, height: 16 }} />}
        label="작성 중"
        sx={{ fontSize: "12px", fontWeight: "bold", "& .MuiChip-label" : { pl: 0.5 } }}
      />
    )
  } else {
    return (
      <Chip
        size="small"
        icon={<GreenCircle />}
        label="매칭 중"
        sx={{ fontSize: "12px", fontWeight: "bold" }}
      />
    )
  }
}

const GreenCircle = styled('span')(({ theme }) => ({
  height: 16,
  width: 16,
  backgroundColor: theme.palette.success.main,
  borderRadius: '50%',
  display: 'inline-block',
}));
